<div class="task-requests-detail">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-2">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-purple-manax text-capitalize title-modal" #top>
          Match Cliente
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <!-- body content -->
  <div *ngIf="!loading" style="border-top: 1px solid #B1AFC1;">

    <div class="row my-3">
      <div class="col-12">
        <p>En base a los datos del cliente proporcionados en la solicitud, hemos encontrado coincidencias que podrían
          corresponder a clientes ya existentes. Si alguno de estos coincide con el cliente que desea registrar en el
          trabajo,
          selecciónelo de la lista. De lo contrario, proceda a crear un nuevo cliente.
        </p>
      </div>
    </div>

    <div class="row my-3">
      <div class="col-12 col-md-4">
        <div class="row my-3 font-manax">
          <div class="col-12 pb-3">
            <h5 class="m-0">
              <i class="material-icons task-icon-color">person</i><b class="bold-item">&nbsp;Nombre:&nbsp;</b>
              {{client?.lastname ? client?.firstname + " " + client?.lastname :  client?.firstname}}
            </h5>
          </div>
        </div>

        <div class="row my-3 font-manax">
          <div class="col-12 pb-3">
            <h5 class="m-0">
              <i class="material-icons task-icon-color">place</i><b class="bold-item">&nbsp;Dirección:&nbsp;</b>
              {{client?.address}}
            </h5>
          </div>
        </div>

        <div class="row my-3 font-manax">
          <div class="col-12 pb-3">
            <h5 class="m-0">
              <i class="material-icons task-icon-color">local_phone</i><b class="bold-item">&nbsp;Telefono:&nbsp;</b>
              {{client?.phone}}
            </h5>
          </div>
        </div>

        <div class="row my-3 font-manax">
          <div class="col-12 pb-3">
            <h5 class="m-0">
              <i class="material-icons task-icon-color">alternate_email</i><b class="bold-item">&nbsp;Email:&nbsp;</b>
              {{client?.email}}
            </h5>
          </div>
        </div>

        <div class="row my-3 font-manax">
          <div class="col-12 pb-3">
            <h5 class="m-0">
              <i class="material-icons task-icon-color">badge</i><b class="bold-item">&nbsp;NIT:&nbsp;</b>
              {{client?.nit}}
            </h5>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-8">
        <div class="table-wrapper table-client-created">
          <table class="table table-hover m-0 align-top">
            <tbody>
              <tr *ngFor="let clientCreated of clients" class='cursor-pointer' (click)="selectClient(clientCreated)">
                <td class="d-table-cell"> {{clientCreated?.firstname}} {{clientCreated?.lastname}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>

    <div class="row my-3" style="border-top: 1px solid #B1AFC1;">
      <div class="col-12 text-center d-flex pt-3" style="justify-content: space-around;">
        <button mat-raised-button type="button" class="m-0 px-3 btn btn-manax" *ngIf="!loading"
          (click)="openTaskRequestClient()">
          Crear Nuevo Cliente
        </button>

      </div>
    </div>
  </div>
</div>